<mat-sidenav-container class="sidenav-container staff-layout">

  <mat-sidenav-content>
    <mat-toolbar  class="mat-elevation-z0 shadow-sm">
      @if (isHandset$ | async) {
        <button (click)="drawer.toggle()" mat-icon-button type="button">
          <mat-icon>menu</mat-icon>
        </button>
      }

      <button mat-icon-button routerLink="/dashboard" type="button">
        <!--        <img alt="" class="w-100 me-2" src="assets/images/emblem.webp">-->
        <span class="fs-6 font-artistic">{{ 'AQRBMIS' | translate | uppercase}}</span>
      </button>

      <span class="spacer"></span>

      <app-main-toolbar></app-main-toolbar>

    </mat-toolbar>

    <div class="content-container">
      <ng-content></ng-content>
    </div>
    <div class=" col-md-12" id="scrollbarTopStyle">
      @for (menuItem of mainMenu; track menuItem) {
        <ng-container>
<!--        <ng-container *ngxPermissionsOnly="menuItem.permissions">-->
          @if (true) {
<!--          @if (menuItem?.userType === loggedInUserType) {-->
            <a class="nav-buttons text-white me-2 my-2"
              routerLink="{{ menuItem.route }}" routerLinkActive="active-top-menu">
              @if (menuItem.iconType === 'SVG') {
                <mat-icon svgIcon="{{ menuItem.icon }}"></mat-icon>
              }
              @if (menuItem?.iconType === 'MATERIAL') {
                <span class="material-symbols-outlined">{{menuItem?.icon}}</span>
              }
              <span>{{ menuItem.name | translate }}</span>
            </a>
          }
        </ng-container>
      }
    </div>

    <div class="top-120 container staff-main  shadow-sm">
      <router-outlet></router-outlet>
    </div>

  </mat-sidenav-content>
</mat-sidenav-container>

